import React from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as EventActions from "../redux/actions/event.actions";
import { NEW_EVENT_ID } from '../redux/reducers/event.reducer';
import eventState from '../models/states/event.state';


type NavigateToCreateEvent = (eventId?: string) => void;

type NavigateToCreateEventHook = () => NavigateToCreateEvent;

const useNavigateToCreateEvent: NavigateToCreateEventHook = () => {
  /** Routing */
  const history = useHistory();
  /* Actions */
  const dispatch = useDispatch();
  const setEventId = (eventId: string) => dispatch(EventActions.setEventId(eventId));
  const createEvent = React.useCallback((eventId = NEW_EVENT_ID) => {
    dispatch(EventActions.setDuplicateEvent(eventId, false))    
    setEventId(eventId);
    const clearState = eventState(eventId)
     if (eventId =="new"){
       dispatch(EventActions.cacheEvents([clearState]));
      }
    history.push(`/create-event/details?eventId=${eventId}`);
  }, []);

  /** Return */
  return createEvent;
};

export default useNavigateToCreateEvent;
